import { visit, parse, extendSchema } from 'graphql';
import { removeFieldIfDirectives, removeDirectives } from './graphql';
export function transformDocumentWithApollo(doc, { keepClientFields }) {
    return visit(doc, {
        Field(node) {
            return keepClientFields
                ? removeDirectives(node, ['client'])
                : removeFieldIfDirectives(node, ['client']);
        },
    });
}
export function transformSchemaWithApollo(schema) {
    return extendSchema(schema, parse(/* GraphQL */ `
      directive @connection(key: String!, filter: [String]) on FIELD
    `));
}
//# sourceMappingURL=apollo.js.map